
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/spa",
      function () {
        return require("private-next-pages/spa/index.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/spa"])
      });
    }
  